import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { deepEqual } from "../../../utils/object";

class TextEx extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            configuration: { ...props.meta },
            data: typeof props.data === "object" ? "" : props.data ?? props.meta?.default ?? "",
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }    

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? "";
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }
    
    onChange = (e) => {
        const newValue = e.target.value;
        if (this.state.data === newValue) return;
        
        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        const multiline = Boolean(this.props.meta?.multiline);
        const configuredRows = Number(this.props.meta?.rows);
        const rows = Number.isSafeInteger(configuredRows) && configuredRows > 0 ? configuredRows : 5;
        return (<>
            <Row className="g-3">
                <Col>
                    <div className="mb-3 top-label">
                        <Form.Control as={multiline ? "textarea" : "input"} type={multiline ? undefined : "text"} rows={multiline ? rows : undefined} aria-label={this.state.label || this.props.element} name={ this.props.element } value={this.state.data || ""} onChange={this.onChange} readOnly={this.state.locked} />
                        <Form.Label>{ this.state.label }</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default TextEx;